import { postFindActivityRemainAmountListByCustomerId } from "../../../request/designordercenter/activityOrderController/findActivityRemainAmountListByCustomerId/post.js";
async function getUnifySelectInventoryRegActivities({
  findActivityRemainAmount,
  orgNo
}) {
  const innerFindActivityRemainAmount = postFindActivityRemainAmountListByCustomerId || findActivityRemainAmount;
  const list = await innerFindActivityRemainAmount({
    customerId: orgNo,
    customerType: 0
  });
  return list && new Map(list.map((activity) => [activity.activityId, activity]));
}
export { getUnifySelectInventoryRegActivities };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/business/unifySelectInventory/activity/getRegActivities.js